var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFamilienrechtTodErbeDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_129_10040)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273.085 321.364C355.246 307.73 410.797 230.074 397.164 147.914C383.53 65.7536 305.874 10.2018 223.713 23.8355C141.553 37.4692 86.0015 115.125 99.6352 197.286C113.269 279.446 190.925 334.998 273.085 321.364Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M289.298 350.698C264.498 365.898 217.398 376.198 163.398 376.198C83.5984 376.198 18.8984 353.698 18.8984 325.998C18.8984 309.198 42.6984 294.298 79.1984 285.198C77.8984 282.098 77.1984 278.998 77.1984 275.798C77.1984 241.498 157.298 213.598 256.198 213.598C355.098 213.598 435.198 241.398 435.198 275.798C435.198 287.898 425.198 299.198 407.898 308.798C436.298 313.898 455.698 324.198 455.698 336.098C455.698 353.098 416.098 366.798 367.198 366.798C333.498 366.898 304.198 360.298 289.298 350.698Z",
    fill: "#D1EDEC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M340.699 221.098C396.999 231.598 435.199 252.198 435.199 275.898C435.199 278.798 434.599 281.598 433.599 284.298L296.199 336.498C280.499 339.098 264.699 340.798 248.899 341.598L207.699 343.698L310.699 220.098L340.699 221.098Z",
    fill: "#015B58"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M299.497 400.898C323.897 400.898 343.697 393.998 343.697 385.498C343.697 376.998 323.797 370.098 299.497 370.098C275.197 370.098 255.297 376.998 255.297 385.498C255.297 393.998 275.197 400.898 299.497 400.898Z",
    fill: "#B4D9D7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.2 291.296C101.6 291.296 121.4 284.396 121.4 275.896C121.4 267.396 101.5 260.496 77.2 260.496C52.8 260.496 33 267.396 33 275.896C33 284.396 52.8 291.296 77.2 291.296Z",
    fill: "#B4D9D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.499 315.996C482.233 315.996 495.799 311.295 495.799 305.496C495.799 299.697 482.233 294.996 465.499 294.996C448.765 294.996 435.199 299.697 435.199 305.496C435.199 311.295 448.765 315.996 465.499 315.996Z",
    fill: "#B4D9D7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.1992 308.996L106.299 271.996C109.699 264.196 116.299 255.996 124.499 253.596L269.599 212.496C280.399 209.496 292.199 206.896 302.699 210.596L366.699 232.596C376.599 235.996 381.899 244.996 386.099 254.596L397.899 281.796L231.999 336.996C207.999 346.796 181.199 347.396 156.799 338.696L90.1992 308.996Z",
    fill: "#823103"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M324.397 218.098L366.597 232.598C373.997 235.098 378.797 240.798 382.597 247.498L366.697 252.398C358.497 247.598 349.097 245.098 339.597 245.098H317.297L324.397 218.098Z",
    fill: "#4A1B00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M378.497 241.297C381.597 245.197 383.997 249.797 385.997 254.597L397.797 281.797L231.997 336.997C213.797 344.497 193.997 346.597 174.797 343.397C176.297 331.697 179.297 320.097 183.797 308.997C187.997 298.697 196.497 290.797 207.097 287.297L378.497 241.297Z",
    fill: "#4A1B00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M343.598 236.998L351.498 157.098C351.798 150.798 347.998 144.998 342.098 142.798L299.798 140.198C298.798 140.098 297.798 140.298 296.798 140.598L269.598 145.798L291.498 155.698V222.998L317.298 245.098L343.598 236.998Z",
    fill: "#B5A7A3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M317.399 245.199L323.299 162.699C323.599 156.399 319.799 150.599 313.899 148.399L271.599 145.799C266.199 145.499 262.699 150.199 262.799 155.499L263.299 228.599L317.399 245.199Z",
    fill: "#998B86"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M289.798 187.998C296.298 187.998 301.698 180.498 301.698 171.298C301.698 162.098 296.398 154.598 289.798 154.598C283.198 154.598 277.898 162.098 277.898 171.298C277.898 180.498 283.198 187.998 289.798 187.998Z",
    fill: "#B5A7A3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.898 194.098L308.298 195.398L307.898 207.698L270.998 203.298L270.898 194.098ZM270.898 208.798L307.598 213.698L307.298 225.898L271.098 217.998L270.898 208.798Z",
    fill: "#B5A7A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408 287.5C405.2 285.8 404.3 282.2 406 279.5C406.2 279.2 406.4 278.9 406.6 278.7L399 202.5L411.7 203.3L415.2 278.4C417.5 280.7 417.5 284.4 415.2 286.7C413.3 288.6 410.3 289 408 287.5Z",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.8 199.6L413.5 224.9L414 240.4L400.1 241.7L397.3 228.8L395.8 194.7C395.6 189.4 399.5 184.7 404.8 184.1C410.3 183.5 415.3 187.4 416.1 192.9L416.8 199.6Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.398 421.998H354.898L350.898 389.398H363.398V421.998Z",
    fill: "#FFB7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.499 430.201H338.199V429.901C338.199 424.001 342.999 419.301 348.799 419.301H365.499V430.201Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.201 421.998H424.801L420.801 389.398H433.301L433.201 421.998Z",
    fill: "#FFB7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.402 430.201H408.102V429.901C408.102 424.001 412.902 419.301 418.702 419.301H435.402V430.201Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.3 172.1C410.407 172.1 418.6 163.907 418.6 153.8C418.6 143.693 410.407 135.5 400.3 135.5C390.193 135.5 382 143.693 382 153.8C382 163.907 390.193 172.1 400.3 172.1Z",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.001 179.602L410.701 181.102C417.001 190.002 418.601 201.402 415.001 211.702L405.401 239.502C405.401 239.502 418.701 266.202 418.701 291.102C418.701 315.902 444.101 404.502 444.101 404.502L408.401 408.202L392.801 313.802L371.301 407.802L346.801 403.802L360.301 280.602L369.201 240.002L369.601 220.202C369.601 220.202 365.801 205.402 375.301 195.902L386.901 179.702L398.001 179.602Z",
    fill: "#003F6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.902 290.6C384.002 288.6 383.202 284.6 385.202 281.7C385.402 281.4 385.702 281.1 385.902 280.8L382.102 197L395.902 198.7L395.302 281C397.702 283.6 397.502 287.7 394.802 290.1C392.602 292.1 389.302 292.3 386.902 290.6Z",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.799 194.999L396.699 222.499L396.299 239.499L380.999 240.099L378.699 225.799L378.999 188.399C379.099 182.499 383.599 177.699 389.499 177.399C395.599 176.999 400.799 181.599 401.299 187.699L401.799 194.999Z",
    fill: "#003F6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379 147.201H406V135.401C400.1 133.001 394.3 131.101 390.8 135.401C384.2 135.501 379 140.701 379 147.201Z",
    fill: "#E1C08A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.399 133.398C423.499 133.398 427.999 153.598 427.999 164.998C427.999 171.398 425.099 173.598 420.599 174.398L418.999 165.898L415.299 174.798C413.999 174.798 412.699 174.798 411.299 174.798L409.999 172.198L407.199 174.798C395.899 174.798 386.699 176.498 386.699 165.098C386.799 153.598 390.699 133.398 407.399 133.398Z",
    fill: "#E1C08A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M383.602 244.999L382.902 215.399L381.102 202.199L376.602 215.299L383.602 244.999Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.099 282.898C174.499 279.998 172.399 277.298 169.399 276.898C169.099 276.898 168.799 276.898 168.499 276.898L163.199 265.898L155.699 267.498L163.399 282.998C163.799 285.998 166.399 288.098 169.399 287.698C171.899 287.298 173.899 285.398 174.099 282.898Z",
    fill: "#FFB7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1016 410.898L65.4016 414.098L80.6016 391.598L71.4016 386.898L59.1016 410.898Z",
    fill: "#FFB7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6 408.102L70.9 414.402C75.2 416.602 76.9 421.902 74.7 426.202L74.6 426.502L54.5 416.202L58.6 408.102Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.102 419.699H138.102L141.402 392.699H131.102V419.699Z",
    fill: "#FFB7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.301 417.398H143.101C148.001 417.398 151.901 421.298 151.901 426.198V426.498H129.301V417.398Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.2984 199.401C98.2984 199.401 93.5984 195.801 93.5984 204.601L92.8984 233.601L101.198 261.001L105.998 252.101L103.998 232.901L98.2984 199.401Z",
    fill: "#003F6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.499 278.7C148.499 278.7 153.899 305.2 147.099 326.9L143.299 410.4L129.299 409.3L124.399 347.3L119.699 316.5L109.899 344.6L77.5992 404L62.6992 392.4C62.6992 392.4 79.1992 347.5 91.2992 338L97.3992 268.5L148.499 278.7Z",
    fill: "#003F6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.002 163.999C140.783 163.999 147.902 156.881 147.902 148.099C147.902 139.318 140.783 132.199 132.002 132.199C123.22 132.199 116.102 139.318 116.102 148.099C116.102 156.881 123.22 163.999 132.002 163.999Z",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.799 151.501C132.699 151.701 134.099 149.801 134.799 148.001C135.499 146.201 135.999 144.101 137.599 143.101C139.899 141.801 142.799 143.401 145.399 142.901C148.299 142.401 150.199 139.301 150.399 136.301C150.499 133.301 149.399 130.501 148.199 127.801L147.799 131.201C147.899 128.901 146.799 126.601 144.899 125.301L145.399 130.301C144.899 127.401 142.199 125.501 139.299 125.901L139.399 128.901C135.999 128.401 132.599 128.201 129.199 128.401C125.799 128.601 122.499 129.901 119.799 132.001C115.999 135.301 114.599 140.801 114.999 145.901C115.499 151.001 117.599 155.701 119.699 160.301C120.199 161.501 120.999 162.801 122.299 162.901C123.499 162.901 124.499 162.101 124.799 161.001C125.099 159.901 125.099 158.701 124.799 157.601C124.299 155.901 124.199 154.201 124.399 152.401C124.699 150.701 125.899 149.001 127.699 148.801C129.399 148.601 131.199 150.601 130.399 152.101L130.799 151.501Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.699 169.799L119.999 165.199C119.999 165.199 123.699 166.499 133.699 171.399L134.399 175.699L151.699 282.099L120.199 280.699L111.599 280.499L105.299 280.399L96.8986 280.199L96.9986 249.799L99.6986 226.399L95.4986 204.299C95.4986 204.299 90.1986 183.999 110.599 173.099L116.699 169.799Z",
    fill: "#003F6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.301 277.202L161.501 281.202L169.501 276.002L166.401 272.602L160.301 277.202Z",
    fill: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.699 182.701C122.699 182.701 135.099 166.901 142.599 184.501L144.999 203.001C144.999 203.001 154.099 226.001 154.299 235.301C154.299 235.301 160.499 247.401 160.399 253.801L169.499 274.401L160.199 280.201L134.399 240.601L122.699 182.701Z",
    fill: "#003F6D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_129_10040"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFamilienrechtTodErbeDark);
export default __webpack_public_path__ + "static/media/Familienrecht_Tod_Erbe_dark.3972847c2a6c3f2e44a69320fdebf6fd.svg";
export { ForwardRef as ReactComponent };